import { render, staticRenderFns } from "./DetalhesFormCarga.vue?vue&type=template&id=dda2dd32&"
import script from "./DetalhesFormCarga.vue?vue&type=script&lang=js&"
export * from "./DetalhesFormCarga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports